var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnabledCircleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 11.5,
    transform: "matrix(-1 0 0 1 11.5 11.5)",
    fill: "#036"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.857 17.192l-6.099-6.099M13.857 5.808l-6.099 6.099",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSByPSIxMS41IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAxMS41IDExLjUpIiBmaWxsPSIjMDAzMzY2Ii8+CjxwYXRoIGQ9Ik0xMy44NTY5IDE3LjE5Mkw3Ljc1ODE0IDExLjA5MzIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xMy44NTY5IDUuODA4MDNMNy43NTgxNCAxMS45MDY4IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K";
export { SvgEnabledCircleLeft as ReactComponent };